<template>
    <b-btn v-if="isAvailable" target="_blank" :to="link" class="btn-card-action btn-danger my-1">
        Ответить на запрос<br />(До {{ getDateTimeFormat(purchase.purchase_info.explanation_request_answer_end_date) }})
    </b-btn>
</template>

<script>
export default {
    name: 'cabinet-fl44-notice-card-answer-explanation-request-button',
    props: {
        purchase: {
            type: Object
        }
    },
    data() {
        return {
            timer: null,
            secondsLeft: 0
        };
    },
    created() {
        this.secondsLeft = this.purchase.purchase_info.explanation_request_answer_seconds_left;
        if (this.purchase.actions.reply_explanation_request) {
            setTimeout(() => (this.secondsLeft = 0), this.secondsLeft * 1000);
        }
    },
    computed: {
        isAvailable() {
            return this.purchase.actions.reply_explanation_request && this.secondsLeft > 0;
        },
        link() {
            return this.purchase.type === 'fl44' ? { name: 'purchases.grouped.item.view', params: { group: 'fl44', id: this.purchase.id }, hash: '#explanation-requests' } : { name: 'Fl44UnknownVolumePurchaseShow', params: { id: this.purchase.id }, hash: '#explanation-requests' };
        }
    }
};
</script>
